import React from "react";
import { Steps, theme } from "antd";
import { FORM_STEPS } from "./PublicClientDataRequestFormConfig";

interface PracticeDataRequestProgressStepsProps {
  requestData: any;
}

const isCompleteStatus = (status: any) =>
  status === "Submitted" ||
  status === "Processed" ||
  status === 2 ||
  status === 3;

const PracticeDataRequestProgressSteps: React.FC<
  PracticeDataRequestProgressStepsProps
> = ({ requestData }) => {
  const { token } = theme.useToken();
  const subtleBorder = `1px solid ${token.colorBorderSecondary}`;

  const complete = isCompleteStatus(requestData?.status);
  const currentStep = requestData?.currentStep || 1;
  const current = complete
    ? FORM_STEPS.length
    : Math.min(Math.max(currentStep - 1, 0), FORM_STEPS.length - 1);

  const getSubTitle = (stepIndex: number) => {
    if (complete || stepIndex < current) return "Completed";
    if (stepIndex > current) return "Pending";
    const activeSection = FORM_STEPS[stepIndex].sections.find(
      (s) => s.key === requestData?.activeSubTab,
    );
    return activeSection?.label || "In progress";
  };

  return (
    <div
      style={{
        padding: "12px 24px",
        background: token.colorBgContainer,
        borderBottom: subtleBorder,
        borderRadius: token.borderRadiusLG,
      }}
    >
      <Steps
        size="small"
        current={current}
        style={{ margin: 0 }}
        items={FORM_STEPS.map((step, index) => ({
          title: (
            <span style={{ fontSize: 12, fontWeight: 600 }}>{step.label}</span>
          ),
          subTitle: (
            <span style={{ fontSize: 10, opacity: 0.85 }}>
              {getSubTitle(index)}
            </span>
          ),
          icon: step.icon,
        }))}
      />
    </div>
  );
};

export default PracticeDataRequestProgressSteps;
